import { updateItemInCollection } from "directus/src/operations";

export async function updateGrade({ item, gradeId }) {
  try {
    const data = await updateItemInCollection("grades", gradeId, item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
